import { useAuth } from '../../context/auth';
import * as T from '../Typography';
import colors from '../../theme/colors';
import * as S from './style';

interface HeaderProps {
  headerType?: 'default' | 'survey';
}

const createFullName = (firstName: string, lastName: string) => {
  return `${firstName} ${lastName}`.toUpperCase();
};

const HeaderContent = ({ headerType }: HeaderProps) => {
  const { user } = useAuth();

  if (headerType === 'survey') {
    return (
      <S.HeaderContent>
        <T.H4>SOCIAL MOBILITY EMPLOYER INDEX</T.H4>
      </S.HeaderContent>
    );
  } else {
    return (
      <S.HeaderContent>
        <T.H4>HELLO, </T.H4>
        <T.H4 color={colors.secondary.main} ml={2}>
          {createFullName(user?.firstName || '', user?.lastName || '')}
        </T.H4>
      </S.HeaderContent>
    );
  }
};

const Header = ({ headerType }: HeaderProps) => {
  return (
    <S.HeaderContainer bgcolor={colors.secondary.shades.shade50}>
      <HeaderContent headerType={headerType} />
    </S.HeaderContainer>
  );
};

export default Header;
